// Some full-screen overlays (ConfirmationOverlay, MultipleTrailerSelection) lock
// background scroll while they're shown, by adding 'modal-open' to <body>
// (styles/_base-control.scss sets `body.modal-open { overflow: hidden }`).
//
// Two overlays used to toggle that class directly with document.body.classList,
// with no coordination between them. That has two failure modes:
//   - stacking: overlay A locks, overlay B opens on top and also locks, B closes
//     and unlocks even though A is still open, leaving A scrollable underneath.
//   - stuck lock: any removal path that doesn't fire a locker's beforeUnmount
//     (an error thrown before it, or a future refactor that misses the symmetry)
//   leaves the class on <body> for the rest of the session. Because the lock has
//   no effect until content taller than the viewport exists, a stuck lock can go
//   unnoticed for a long time on a tall desktop window and only surface once
//   someone hits it on a short mobile viewport, which is exactly what makes this
//   class of bug so easy to ship and hard to catch on desktop.
//
// A small reference count fixes the stacking case, and resetBodyScrollLock (wired
// to fire after every completed route change) is a hard safety net for the stuck
// case: none of these overlays are meant to remain open across a navigation, so
// forcing the count back to zero on every route change can't unlock a legitimate
// open overlay, only clean up a leak.
let lockCount = 0;

export function lockBodyScroll(): void {
    lockCount += 1;
    document.body.classList.add('modal-open');
}

export function unlockBodyScroll(): void {
    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0) {
        document.body.classList.remove('modal-open');
    }
}

export function resetBodyScrollLock(): void {
    lockCount = 0;
    document.body.classList.remove('modal-open');
}
